import {FranchiseResultModel} from '../services/inventory/inventory.service';

export function normalizeString(str: string): string {
  return str.toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function customFranchiseSearchFn(term: string, item: FranchiseResultModel): boolean {
  if (!term) return true;

  const searchTerm = normalizeString(term);
  const name = normalizeString(item.name || '');
  const description = normalizeString(item.description || '');

  const searchWords = searchTerm.split(' ').filter(word => word.length > 0);

  return searchWords.every(word =>
    name.includes(word) || description.includes(word)
  );
}
